module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-box"
  }, [_c('div', {
    staticClass: "footer-text"
  }, [_c('span', {
    on: {
      "click": _vm.toTermsOfService
    }
  }, [_vm._v("利用規約")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.toPrivacyPolicy
    }
  }, [_vm._v("プライバシーポリシー")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.toFeedback
    }
  }, [_vm._v("問い合わせ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76a2c8c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 895
// module chunks = 1